import utilities from '@/helpers/utilities';
import store from '@/store';

export default {
    build() {
        const officeId = store.getters.profile ? store.getters.profile.office : null;

        return {
            isHired: false,
            isUpdateRequired: false,
            isAdmin: false,
            emailAddress: '',
            area: { id: null },
            office: { id: officeId },
            substitute: { id: null },
            substitutionTerm: {
                start: null,
                finish: null,
            },
            substitutes: [],
            substitutedInDemands: [],
            substitutingInDemands: [],
            name: '',
            username: '',
            isRoot: false,
            isActive: false,
            isOutsourced: false,
            approverOf: [],
        };
    },

    toForm(obj) {
        return utilities.toForm(obj, this.build());
    },

    toPayload(obj) {
        const clone = utilities.toPayload(obj);

        if (clone.isHired) {
            clone.area = null;
            clone.office = null;
        }

        if (!clone.substitute) clone.substitutionTerm = null;

        return clone;
    },
};



// WEBPACK FOOTER //
// ./src/helpers/entities/Person.js